export const A_B_TESTING = 'A_B_TESTING';
export const ACADEMIC_EDUCATION = 'ACADEMIC_EDUCATION';
export const ACCESS_CONTROLS_PERMISSIONS = 'ACCESS_CONTROLS_PERMISSIONS';
export const ACCESSIBILITY_ACCESS_PERMISSIONS = 'ACCESSIBILITY_ACCESS_PERMISSIONS';
export const ACCOUNT_ALERTS = 'ACCOUNT_ALERTS';
export const ACCOUNT_BASED_ENGAGEMENT = 'ACCOUNT_BASED_ENGAGEMENT';
export const ACCOUNT_IDENTIFICATION = 'ACCOUNT_IDENTIFICATION';
export const ACCOUNT_INTELLIGENCE = 'ACCOUNT_INTELLIGENCE';
export const ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT';
export const ACCOUNTING_INTEGRATION = 'ACCOUNTING_INTEGRATION';
export const ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE';
export const ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE';
export const ACTIVITIES = 'ACTIVITIES';
export const ACTIVITY_STREAM_AT_MENTION = 'ACTIVITY_STREAM_AT_MENTION';
export const ACTIVITY_TRACKING = 'ACTIVITY_TRACKING';
export const ADD_ONS = 'ADD_ONS';
export const ADVANCED_DOCUMENT_MANAGEMENT = 'ADVANCED_DOCUMENT_MANAGEMENT';
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH';
export const ADVERTISING = 'ADVERTISING';
export const AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE = 'AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE';
export const AGILE_METHODOLOGIES = 'AGILE_METHODOLOGIES';
export const ALERTS = 'ALERTS';
export const ALERTS_ESCALATION = 'ALERTS_ESCALATION';
export const ALERTS_NOTIFICATIONS = 'ALERTS_NOTIFICATIONS';
export const ANALYTICS = 'ANALYTICS';
export const ANALYTICS_REPORTING = 'ANALYTICS_REPORTING';
export const ANALYTICS_ROI_TRACKING = 'ANALYTICS_ROI_TRACKING';
export const ANNOTATION = 'ANNOTATION';
export const ANSWER_FLOWS = 'ANSWER_FLOWS';
export const ANSWER_SCORING = 'ANSWER_SCORING';
export const APPOINTMENT_SCHEDULING = 'APPOINTMENT_SCHEDULING';
export const APPOINTMENT_SETTING = 'APPOINTMENT_SETTING';
export const APPROVAL_PROCESS = 'APPROVAL_PROCESS';
export const ARCHIVING = 'ARCHIVING';
export const ARTIFICIAL_INTELLIGENCE = 'ARTIFICIAL_INTELLIGENCE';
export const ASSET_MANAGEMENT = 'ASSET_MANAGEMENT';
export const ASYNCHRONOUS_LEARNING = 'ASYNCHRONOUS_LEARNING';
export const ATTENDEE_MANAGEMENT = 'ATTENDEE_MANAGEMENT';
export const ATTENDEE_NETWORKING = 'ATTENDEE_NETWORKING';
export const ATTENDEE_REPORTS = 'ATTENDEE_REPORTS';
export const ATTRIBUTION_REPORTING = 'ATTRIBUTION_REPORTING';
export const AUDIT_TRAIL = 'AUDIT_TRAIL';
export const AUDITING = 'AUDITING';
export const AUTO_TAX_PAYMENTS = 'AUTO_TAX_PAYMENTS';
export const AUTO_UPDATE = 'AUTO_UPDATE';
export const AUTOMATED_EMAIL_RESPONSES = 'AUTOMATED_EMAIL_RESPONSES';
export const AUTOMATED_PUBLISHING = 'AUTOMATED_PUBLISHING';
export const AUTOMATED_ROUTING = 'AUTOMATED_ROUTING';
export const AUTOMATED_SCHEDULING = 'AUTOMATED_SCHEDULING';
export const AUTOMATIC_CALL_DISTRIBUTORS = 'AUTOMATIC_CALL_DISTRIBUTORS';
export const AUTOMATION = 'AUTOMATION';
export const AUTOMATION_TOOLS = 'AUTOMATION_TOOLS';
export const AUTORESPONDERS = 'AUTORESPONDERS';
export const BADGE_MANAGEMENT = 'BADGE_MANAGEMENT';
export const BARCODE_TICKET_SCANNING = 'BARCODE_TICKET_SCANNING';
export const BASELINING_KPIS = 'BASELINING_KPIS';
export const BENCHMARKING = 'BENCHMARKING';
export const BENEFITS_MANAGEMENT = 'BENEFITS_MANAGEMENT';
export const BID_MANAGEMENT = 'BID_MANAGEMENT';
export const BILLING_INVOICING = 'BILLING_INVOICING';
export const BLENDED_CALL_CENTER = 'BLENDED_CALL_CENTER';
export const BLOGGING = 'BLOGGING';
export const BOX_OFFICE_MANAGEMENT = 'BOX_OFFICE_MANAGEMENT';
export const BRAND_ALERTS = 'BRAND_ALERTS';
export const BRAND_MANAGEMENT = 'BRAND_MANAGEMENT';
export const BRAND_MONITORING = 'BRAND_MONITORING';
export const BRAND_OPTIMIZATION = 'BRAND_OPTIMIZATION';
export const BRAND_OVERLAY = 'BRAND_OVERLAY';
export const BRAND_TRACKING = 'BRAND_TRACKING';
export const BRANDING = 'BRANDING';
export const BUDGET_MANAGEMENT = 'BUDGET_MANAGEMENT';
export const BUDGETING_FORECASTING = 'BUDGETING_FORECASTING';
export const BUILDING_AND_PERSONALIZING_EMAILS = 'BUILDING_AND_PERSONALIZING_EMAILS';
export const BUILDING_PERSONALIZING_EMAILS = 'BUILDING_PERSONALIZING_EMAILS';
export const BULK_EMAIL_SENDING = 'BULK_EMAIL_SENDING';
export const BULK_SMS = 'BULK_SMS';
export const BULK_UPDATES = 'BULK_UPDATES';
export const BULK_UPLOADING = 'BULK_UPLOADING';
export const BUSINESS_PROCESS_AUTOMATION = 'BUSINESS_PROCESS_AUTOMATION';
export const CALENDAR_MANAGEMENT = 'CALENDAR_MANAGEMENT';
export const CALENDAR_REMINDER_SYSTEM = 'CALENDAR_REMINDER_SYSTEM';
export const CALENDAR_VIEW = 'CALENDAR_VIEW';
export const CALENDARS = 'CALENDARS';
export const CALL_BARGING = 'CALL_BARGING';
export const CALL_LOGGING = 'CALL_LOGGING';
export const CALL_RECORDING_PLAYBACK = 'CALL_RECORDING_PLAYBACK';
export const CALL_ROUTING = 'CALL_ROUTING';
export const CALL_SCRIPTING = 'CALL_SCRIPTING';
export const CALL_SHARING = 'CALL_SHARING';
export const CALL_SUMMARY_NOTES = 'CALL_SUMMARY_NOTES';
export const CALLBACK_SCHEDULING = 'CALLBACK_SCHEDULING';
export const CAMPAIGN_INSIGHTS = 'CAMPAIGN_INSIGHTS';
export const CAMPAIGN_MANAGEMENT = 'CAMPAIGN_MANAGEMENT';
export const CAMPAIGN_PERSONALIZATION = 'CAMPAIGN_PERSONALIZATION';
export const CANNED_RESPONSES = 'CANNED_RESPONSES';
export const CART_ABANDONMENT = 'CART_ABANDONMENT';
export const CATALOG_MANAGEMENT = 'CATALOG_MANAGEMENT';
export const CATALOGING_CATEGORIZATION = 'CATALOGING_CATEGORIZATION';
export const CENTRAL_DATABASE = 'CENTRAL_DATABASE';
export const CHANNEL_ANALYTICS = 'CHANNEL_ANALYTICS';
export const CHANNEL_ATTRIBUTION = 'CHANNEL_ATTRIBUTION';
export const CHAT_MONITORING = 'CHAT_MONITORING';
export const CHAT_RATING = 'CHAT_RATING';
export const CHAT_ROUTING = 'CHAT_ROUTING';
export const CLEANSE_STANDARDIZE_DATA = 'CLEANSE_STANDARDIZE_DATA';
export const CLICK_TO_CALL = 'CLICK_TO_CALL';
export const CLOSED_CAPTIONS = 'CLOSED_CAPTIONS';
export const COLLABORATION = 'COLLABORATION';
export const COLLABORATIVE_PROJECT_PLANNING = 'COLLABORATIVE_PROJECT_PLANNING';
export const COLLECTION = 'COLLECTION';
export const COMMENTS = 'COMMENTS';
export const COMMISSION_MANAGEMENT = 'COMMISSION_MANAGEMENT';
export const COMPETITIVE_ANALYSIS = 'COMPETITIVE_ANALYSIS';
export const COMPETITOR_ANALYSIS = 'COMPETITOR_ANALYSIS';
export const COMPLIANCE_TRACKING = 'COMPLIANCE_TRACKING';
export const COMPUTER_TELEPHONY_INTEGRATION = 'COMPUTER_TELEPHONY_INTEGRATION';
export const CONCESSIONS_MANAGEMENT = 'CONCESSIONS_MANAGEMENT';
export const CONFERENCES_CONVENTIONS = 'CONFERENCES_CONVENTIONS';
export const CONTACT_ACCOUNT_MANAGEMENT = 'CONTACT_ACCOUNT_MANAGEMENT';
export const CONTACT_DATABASE_MANAGEMENT = 'CONTACT_DATABASE_MANAGEMENT';
export const CONTACT_DISCOVERY = 'CONTACT_DISCOVERY';
export const CONTACT_IMPORT_EXPORT = 'CONTACT_IMPORT_EXPORT';
export const CONTACT_LIST_MANAGEMENT = 'CONTACT_LIST_MANAGEMENT';
export const CONTACT_MANAGEMENT = 'CONTACT_MANAGEMENT';
export const CONTENT_AGGREGATION = 'CONTENT_AGGREGATION';
export const CONTENT_AUTHORING = 'CONTENT_AUTHORING';
export const CONTENT_CREATION = 'CONTENT_CREATION';
export const CONTENT_DELIVERY = 'CONTENT_DELIVERY';
export const CONTENT_IMPORT_EXPORT = 'CONTENT_IMPORT_EXPORT';
export const CONTENT_MANAGEMENT = 'CONTENT_MANAGEMENT';
export const CONTENT_QUEUE = 'CONTENT_QUEUE';
export const CONTENT_REPOSITORY = 'CONTENT_REPOSITORY';
export const CONTENT_TAXONOMY = 'CONTENT_TAXONOMY';
export const CONTRACT_LICENSE_MANAGEMENT = 'CONTRACT_LICENSE_MANAGEMENT';
export const CONTROLLED_TELEPHONY = 'CONTROLLED_TELEPHONY';
export const CONVERSATION_ARCHIVING = 'CONVERSATION_ARCHIVING';
export const CONVERSION_TRACKING = 'CONVERSION_TRACKING';
export const CONVERSIONS = 'CONVERSIONS';
export const CORE_HR_INTEGRATION = 'CORE_HR_INTEGRATION';
export const CORPORATE_BUSINESS = 'CORPORATE_BUSINESS';
export const COUNTERFEIT_DETECTION = 'COUNTERFEIT_DETECTION';
export const COURSE_FUNNELS_ROADMAPS = 'COURSE_FUNNELS_ROADMAPS';
export const COURSE_MATERIAL_DATABASES = 'COURSE_MATERIAL_DATABASES';
export const CRM = 'CRM';
export const CRM_INTEGRATION = 'CRM_INTEGRATION';
export const CRM_LEAD_INTEGRATION = 'CRM_LEAD_INTEGRATION';
export const CROSS_CHANNEL_FULFILLMENT = 'CROSS_CHANNEL_FULFILLMENT';
export const CUSTOM_REPORTING = 'CUSTOM_REPORTING';
export const CUSTOM_SURVEY_URLS = 'CUSTOM_SURVEY_URLS';
export const CUSTOMER_ANALYTICS_SEGMENTATION = 'CUSTOMER_ANALYTICS_SEGMENTATION';
export const CUSTOMER_DATABASE = 'CUSTOMER_DATABASE';
export const CUSTOMER_ENGAGEMENT = 'CUSTOMER_ENGAGEMENT';
export const CUSTOMER_JOURNEY_MAPPING = 'CUSTOMER_JOURNEY_MAPPING';
export const CUSTOMER_PORTAL = 'CUSTOMER_PORTAL';
export const CUSTOMER_PROFILE_INTERVIEW = 'CUSTOMER_PROFILE_INTERVIEW';
export const CUSTOMER_PROFILES = 'CUSTOMER_PROFILES';
export const CUSTOMER_SATISFACTION_SURVEY = 'CUSTOMER_SATISFACTION_SURVEY';
export const CUSTOMER_SCHEDULING = 'CUSTOMER_SCHEDULING';
export const CUSTOMER_SEGMENTATION = 'CUSTOMER_SEGMENTATION';
export const CUSTOMIZABLE_BRANDING = 'CUSTOMIZABLE_BRANDING';
export const CUSTOMIZABLE_DASHBOARD = 'CUSTOMIZABLE_DASHBOARD';
export const CUSTOMIZABLE_TEMPLATES = 'CUSTOMIZABLE_TEMPLATES';
export const CUSTOMIZATION = 'CUSTOMIZATION';
export const DASHBOARD = 'DASHBOARD';
export const DASHBOARDS = 'DASHBOARDS';
export const DATA_ANALYSIS_TOOLS = 'DATA_ANALYSIS_TOOLS';
export const DATA_COLLECTION = 'DATA_COLLECTION';
export const DATA_ENRICHMENT = 'DATA_ENRICHMENT';
export const DATA_FORMATING = 'DATA_FORMATING';
export const DATA_IMPORT_EXPORT = 'DATA_IMPORT_EXPORT';
export const DATA_IMPORT_EXPORT_TOOLS = 'DATA_IMPORT_EXPORT_TOOLS';
export const DATA_MIGRATION = 'DATA_MIGRATION';
export const DATA_VISUALIZATION = 'DATA_VISUALIZATION';
export const DATABASE_MANAGEMENT = 'DATABASE_MANAGEMENT';
export const DEAL_MANAGEMENT_PROMOTIONS = 'DEAL_MANAGEMENT_PROMOTIONS';
export const DECISION_TREE = 'DECISION_TREE';
export const DELIVERY = 'DELIVERY';
export const DEPENDENCIES = 'DEPENDENCIES';
export const DIRECT_DEPOSIT = 'DIRECT_DEPOSIT';
export const DISCUSSION_BOARDS = 'DISCUSSION_BOARDS';
export const DISPATCHING = 'DISPATCHING';
export const DISPOSITION_CODES = 'DISPOSITION_CODES';
export const DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT';
export const DOCUMENT_STORAGE = 'DOCUMENT_STORAGE';
export const DOMAIN_NAME = 'DOMAIN_NAME';
export const DRAG_DROP = 'DRAG_DROP';
export const DRIP_CAMPAIGNS = 'DRIP_CAMPAIGNS';
export const DUE_DATES = 'DUE_DATES';
export const DYNAMIC_CONTENT = 'DYNAMIC_CONTENT';
export const E_COMMERCE = 'E_COMMERCE';
export const EASY_ADMINISTRATION = 'EASY_ADMINISTRATION';
export const EASY_INTEGRATIONS = 'EASY_INTEGRATIONS';
export const ECOMMERCE = 'ECOMMERCE';
export const ECOMMERCE_MANAGEMENT = 'ECOMMERCE_MANAGEMENT';
export const EFFECTIVE_REPORTING_ANALYTICS = 'EFFECTIVE_REPORTING_ANALYTICS';
export const EFFECTIVE_TIME_TRACKING = 'EFFECTIVE_TIME_TRACKING';
export const EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT = 'EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT';
export const ELEARNING_COMPANIES = 'ELEARNING_COMPANIES';
export const EMAIL_AUTOMATION = 'EMAIL_AUTOMATION';
export const EMAIL_CUSTOMIZATION = 'EMAIL_CUSTOMIZATION';
export const EMAIL_INTEGRATION = 'EMAIL_INTEGRATION';
export const EMAIL_INTEGRATIONS = 'EMAIL_INTEGRATIONS';
export const EMAIL_MARKETING = 'EMAIL_MARKETING';
export const EMAIL_MOBILE_PREVIEW = 'EMAIL_MOBILE_PREVIEW';
export const EMAIL_TO_CASE = 'EMAIL_TO_CASE';
export const EMAIL_TRACKING = 'EMAIL_TRACKING';
export const EMPLOYEE_SCHEDULING = 'EMPLOYEE_SCHEDULING';
export const ENGAGEMENT_MONITORING = 'ENGAGEMENT_MONITORING';
export const ENTERPRISE_SCALABILITY = 'ENTERPRISE_SCALABILITY';
export const ESCALATION_MANAGEMENT = 'ESCALATION_MANAGEMENT';
export const ETL = 'ETL';
export const EVENT_CREATION = 'EVENT_CREATION';
export const EVENT_MANAGEMENT = 'EVENT_MANAGEMENT';
export const EVENT_MARKETING = 'EVENT_MARKETING';
export const EVENT_REPORTING = 'EVENT_REPORTING';
export const EVENT_TRIGGERED_EMAIL = 'EVENT_TRIGGERED_EMAIL';
export const EVENT_WEBSITE_CREATION = 'EVENT_WEBSITE_CREATION';
export const EXHIBIT_VENDOR_MANAGEMENT = 'EXHIBIT_VENDOR_MANAGEMENT';
export const EXPENSE_MANAGEMENT = 'EXPENSE_MANAGEMENT';
export const EXPERTISE_LOCATION = 'EXPERTISE_LOCATION';
export const EXPORT_INFORMATION = 'EXPORT_INFORMATION';
export const EXTRACT_TRANSFER_LOAD = 'EXTRACT_TRANSFER_LOAD';
export const FACILITY_SCHEDULING = 'FACILITY_SCHEDULING';
export const FEE_CALCULATOR = 'FEE_CALCULATOR';
export const FILE_SHARING = 'FILE_SHARING';
export const FILE_TRANSFER = 'FILE_TRANSFER';
export const FILE_TRANSFERS = 'FILE_TRANSFERS';
export const FILE_VIEWING = 'FILE_VIEWING';
export const FINANCIAL_MANAGEMENT = 'FINANCIAL_MANAGEMENT';
export const FIRMOGRAPHIC = 'FIRMOGRAPHIC';
export const FLOWS = 'FLOWS';
export const FORECASTING = 'FORECASTING';
export const FORMS = 'FORMS';
export const FORMS_MANAGEMENT = 'FORMS_MANAGEMENT';
export const FORUMS = 'FORUMS';
export const FRAUD_PROTECTION = 'FRAUD_PROTECTION';
export const FULL_TEXT_SEARCH = 'FULL_TEXT_SEARCH';
export const FUND_ACCOUNTING = 'FUND_ACCOUNTING';
export const FUNDRAISING_MANAGEMENT = 'FUNDRAISING_MANAGEMENT';
export const GALLERIES = 'GALLERIES';
export const GAMIFICATION = 'GAMIFICATION';
export const GANTT_CHARTS = 'GANTT_CHARTS';
export const GENERAL_ADMISSION = 'GENERAL_ADMISSION';
export const GEO_TARGETING = 'GEO_TARGETING';
export const GOAL_MANAGEMENT = 'GOAL_MANAGEMENT';
export const GOALS_QUOTA_MANAGEMENT = 'GOALS_QUOTA_MANAGEMENT';
export const GRAPHICAL_WORKFLOW_EDITOR = 'GRAPHICAL_WORKFLOW_EDITOR';
export const GROUP_SCHEDULING = 'GROUP_SCHEDULING';
export const HELP_DESK = 'HELP_DESK';
export const HIGH_VOLUME_SENDING = 'HIGH_VOLUME_SENDING';
export const HOME_PRINTING = 'HOME_PRINTING';
export const HOSTING = 'HOSTING';
export const HR_MANAGEMENT = 'HR_MANAGEMENT';
export const HTML_INPUT = 'HTML_INPUT';
export const IDEA_MANAGEMENT = 'IDEA_MANAGEMENT';
export const IDEAL_CUSTOMER_PROFILE = 'IDEAL_CUSTOMER_PROFILE';
export const IMAGE_GALLERY = 'IMAGE_GALLERY';
export const IN_APP_MESSAGING = 'IN_APP_MESSAGING';
export const INBOUND_CALL_CENTER = 'INBOUND_CALL_CENTER';
export const INBOUND_CALLING = 'INBOUND_CALLING';
export const INSIGHTFUL_VIEWS = 'INSIGHTFUL_VIEWS';
export const INSTANT_RETRIEVAL = 'INSTANT_RETRIEVAL';
export const INTEGRATION = 'INTEGRATION';
export const INTEGRATION_APIS = 'INTEGRATION_APIS';
export const INTEGRATIONS = 'INTEGRATIONS';
export const INTERACTION_TRACKING = 'INTERACTION_TRACKING';
export const INTERACTIVE_VOICE_RESPONSE = 'INTERACTIVE_VOICE_RESPONSE';
export const INTERNAL_CHAT_INTEGRATION = 'INTERNAL_CHAT_INTEGRATION';
export const INTERNATIONALIZATION = 'INTERNATIONALIZATION';
export const INVENTORY_MANAGEMENT = 'INVENTORY_MANAGEMENT';
export const INVENTORY_TRACKING = 'INVENTORY_TRACKING';
export const INVENTORY_REPORTING = 'INVENTORY_REPORTING';
export const INVOICE_CUSTOMIZATION = 'INVOICE_CUSTOMIZATION';
export const IT_ASSET_MANAGEMENT = 'IT_ASSET_MANAGEMENT';
export const IVR_VOICE_RECOGNITION = 'IVR_VOICE_RECOGNITION';
export const JOURNAL_ENTRIES = 'JOURNAL_ENTRIES';
export const KEYWORD_ANALYSIS = 'KEYWORD_ANALYSIS';
export const KEYWORD_RESEARCH = 'KEYWORD_RESEARCH';
export const KEYWORD_TRACKING = 'KEYWORD_TRACKING';
export const KIOSK_TICKETING = 'KIOSK_TICKETING';
export const KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
export const KNOWLEDGE_BASE_MANAGEMENT = 'KNOWLEDGE_BASE_MANAGEMENT';
export const KPI_BASED_REPORTS = 'KPI_BASED_REPORTS';
export const LANDING_PAGES_WEB_FORMS = 'LANDING_PAGES_WEB_FORMS';
export const LEAD_ANAYSIS = 'LEAD_ANAYSIS';
export const LEAD_CAPTURE = 'LEAD_CAPTURE';
export const LEAD_DATABASE_INTEGRATION = 'LEAD_DATABASE_INTEGRATION';
export const LEAD_DEVELOPMENT = 'LEAD_DEVELOPMENT';
export const LEAD_GENERATION_RETRIEVAL = 'LEAD_GENERATION_RETRIEVAL';
export const LEAD_MANAGEMENT = 'LEAD_MANAGEMENT';
export const LEAD_NURTURING = 'LEAD_NURTURING';
export const LEAD_SCORING = 'LEAD_SCORING';
export const LEAD_SEGMENTATION = 'LEAD_SEGMENTATION';
export const LEAVE_TRACKING = 'LEAVE_TRACKING';
export const LIFECYCLE_MANAGEMENT = 'LIFECYCLE_MANAGEMENT';
export const LINK_MANAGEMENT = 'LINK_MANAGEMENT';
export const LINK_SHARING = 'LINK_SHARING';
export const LIVE_CHAT = 'LIVE_CHAT';
export const LIVE_PRESENTATION = 'LIVE_PRESENTATION';
export const LOCALIZATION = 'LOCALIZATION';
export const MAILING_LIST_MANAGEMENT = 'MAILING_LIST_MANAGEMENT';
export const MAKE_RECEIVE_RECORD_CALLS = 'MAKE_RECEIVE_RECORD_CALLS';
export const MANAGEMENT = 'MANAGEMENT';
export const MANUAL_DIALER = 'MANUAL_DIALER';
export const MANUFACTURING = 'MANUFACTURING';
export const MARKETING_AUTOMATION_INTEGRATION = 'MARKETING_AUTOMATION_INTEGRATION';
export const MARKETING_LEAD_DATABASE = 'MARKETING_LEAD_DATABASE';
export const MARKETING_TOOLS = 'MARKETING_TOOLS';
export const MARKETPLACE_FEATURES = 'MARKETPLACE_FEATURES';
export const MEDIA = 'MEDIA';
export const MEETING_MANAGEMENT = 'MEETING_MANAGEMENT';
export const MEMBERSHIP = 'MEMBERSHIP';
export const MERGE_DUPLICATES = 'MERGE_DUPLICATES';
export const METADATA_MANAGEMENT = 'METADATA_MANAGEMENT';
export const MILESTONE_TRACKING = 'MILESTONE_TRACKING';
export const MOBILE = 'MOBILE';
export const MOBILE_ACCESS = 'MOBILE_ACCESS';
export const MOBILE_APP = 'MOBILE_APP';
export const MOBILE_APPS = 'MOBILE_APPS';
export const MOBILE_CHECK_IN = 'MOBILE_CHECK_IN';
export const MOBILE_OPTIMIZATION = 'MOBILE_OPTIMIZATION';
export const MOBILE_OPTIONS = 'MOBILE_OPTIONS';
export const MOBILE_PRESENTATION = 'MOBILE_PRESENTATION';
export const MOBILE_SCREEN_SUPPORT = 'MOBILE_SCREEN_SUPPORT';
export const MOBILE_SEARCH_TRACKING = 'MOBILE_SEARCH_TRACKING';
export const MOBILE_SUPPORT = 'MOBILE_SUPPORT';
export const MOBILE_SURVEY = 'MOBILE_SURVEY';
export const MOBILE_TICKETING = 'MOBILE_TICKETING';
export const MODERATION = 'MODERATION';
export const MULTI_ACCOUNT_MANAGEMENT = 'MULTI_ACCOUNT_MANAGEMENT';
export const MULTI_CHANNEL_COMMUNICATION = 'MULTI_CHANNEL_COMMUNICATION';
export const MULTI_HOSTS = 'MULTI_HOSTS';
export const MULTI_LOCATION = 'MULTI_LOCATION';
export const MULTI_USER_COLLABORATION = 'MULTI_USER_COLLABORATION';
export const MULTILINGUAL_SUPPORT = 'MULTILINGUAL_SUPPORT';
export const MULTIMEDIA_MESSAGING_SERVICE = 'MULTIMEDIA_MESSAGING_SERVICE';
export const MULTIMEDIA_SUPPORT = 'MULTIMEDIA_SUPPORT';
export const MULTIPLE_DATA_SOURCES = 'MULTIPLE_DATA_SOURCES';
export const NETWORK_MONITORING = 'NETWORK_MONITORING';
export const NEWSLETTERS = 'NEWSLETTERS';
export const NONPROFITS = 'NONPROFITS';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const OFFLINE_FORM = 'OFFLINE_FORM';
export const OFFLINE_RESPONSE_COLLECTION = 'OFFLINE_RESPONSE_COLLECTION';
export const OMNICHANNEL_COMMUNICATIONS = 'OMNICHANNEL_COMMUNICATIONS';
export const ON_SITE_EVENT_MANAGEMENT = 'ON_SITE_EVENT_MANAGEMENT';
export const ONBOARDING = 'ONBOARDING';
export const ONLINE_BEHAVIOR_TRACKING = 'ONLINE_BEHAVIOR_TRACKING';
export const ONLINE_BOOKING = 'ONLINE_BOOKING';
export const ONLINE_BOOKING_TOOLS = 'ONLINE_BOOKING_TOOLS';
export const ONLINE_EVENT_REGISTRATION = 'ONLINE_EVENT_REGISTRATION';
export const ONLINE_LECTURES_WORKSHOPS = 'ONLINE_LECTURES_WORKSHOPS';
export const ONLINE_PAYMENT_ACCEPTANCE = 'ONLINE_PAYMENT_ACCEPTANCE';
export const ONLINE_STORE_BUILDER = 'ONLINE_STORE_BUILDER';
export const ONLINE_TICKETING = 'ONLINE_TICKETING';
export const ONSITE_MANAGEMENT = 'ONSITE_MANAGEMENT';
export const ONSITE_TICKETING = 'ONSITE_TICKETING';
export const OPEN_API = 'OPEN_API';
export const OPERATOR_MONITORING = 'OPERATOR_MONITORING';
export const OPPORTUNITY_MANAGEMENT = 'OPPORTUNITY_MANAGEMENT';
export const OPPORTUNITY_PIPELINE_MANAGEMENT = 'OPPORTUNITY_PIPELINE_MANAGEMENT';
export const ORDER_FULFILLMENT = 'ORDER_FULFILLMENT';
export const ORDER_MANAGEMENT = 'ORDER_MANAGEMENT';
export const OUTBOUND_CALL_CENTER = 'OUTBOUND_CALL_CENTER';
export const PAGE_MANAGEMENT = 'PAGE_MANAGEMENT';
export const PARTNER_PORTAL = 'PARTNER_PORTAL';
export const PAYMENT_GATEWAY_INTEGRATION = 'PAYMENT_GATEWAY_INTEGRATION';
export const PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';
export const PAYROLL_ENTRY = 'PAYROLL_ENTRY';
export const PCI_COMPLIANCE = 'PCI_COMPLIANCE';
export const PEER_RECOGNITION = 'PEER_RECOGNITION';
export const PERFORMANCE_MANAGEMENT = 'PERFORMANCE_MANAGEMENT';
export const PERSONALIZATION = 'PERSONALIZATION';
export const PIPELINE_MANAGEMENT = 'PIPELINE_MANAGEMENT';
export const PLAN_MANAGEMENT = 'PLAN_MANAGEMENT';
export const PLATFORM_INTEGRATION = 'PLATFORM_INTEGRATION';
export const PLUGINS = 'PLUGINS';
export const POINTS_OF_CONTACT = 'POINTS_OF_CONTACT';
export const POLLS_VOTING = 'POLLS_VOTING';
export const POP_UP_CHAT = 'POP_UP_CHAT';
export const PORTFOLIO_MANAGEMENT = 'PORTFOLIO_MANAGEMENT';
export const POS = 'POS';
export const POST_SCHEDULING = 'POST_SCHEDULING';
export const PRE_BUILT_TEMPLATES = 'PRE_BUILT_TEMPLATES';
export const PREDICTIVE_ANALYTICS = 'PREDICTIVE_ANALYTICS';
export const PREDICTIVE_DIALER = 'PREDICTIVE_DIALER';
export const PRESENTATION_MANAGEMENT = 'PRESENTATION_MANAGEMENT';
export const PRIVACY_OPTIONS = 'PRIVACY_OPTIONS';
export const PROACTIVE_CHAT = 'PROACTIVE_CHAT';
export const PRODUCT_RECOMMENDATIONS = 'PRODUCT_RECOMMENDATIONS';
export const PRODUCT_REVIEWS = 'PRODUCT_REVIEWS';
export const PRODUCT_VISUALIZATION = 'PRODUCT_VISUALIZATION';
export const PROGRESS_TRACKING = 'PROGRESS_TRACKING';
export const PROGRESSIVE_DIALER = 'PROGRESSIVE_DIALER';
export const PROGRESSIVE_PROFILING = 'PROGRESSIVE_PROFILING';
export const PROJECT_MANAGEMENT_WITH_BOARDS = 'PROJECT_MANAGEMENT_WITH_BOARDS';
export const PROJECT_TAGS_FOLDERS = 'PROJECT_TAGS_FOLDERS';
export const PROJECT_TRACKING = 'PROJECT_TRACKING';
export const PROMOTIONS_COUPONS = 'PROMOTIONS_COUPONS';
export const PROPOSAL_MANAGEMENT = 'PROPOSAL_MANAGEMENT';
export const PROSPECTING_TOOLS = 'PROSPECTING_TOOLS';
export const PUBLIC_PRIVATE = 'PUBLIC_PRIVATE';
export const PURCHASE_ORDERS = 'PURCHASE_ORDERS';
export const PURCHASING = 'PURCHASING';
export const Q_A = 'Q_A';
export const QUESTION_CONDITIONS = 'QUESTION_CONDITIONS';
export const QUESTION_LIBRARY = 'QUESTION_LIBRARY';
export const QUEUE_MANAGEMENT = 'QUEUE_MANAGEMENT';
export const QUEUE_TIMES = 'QUEUE_TIMES';
export const QUOTES_ESTIMATES = 'QUOTES_ESTIMATES';
export const RANK_TRACKING = 'RANK_TRACKING';
export const REAL_TIME_CHAT = 'REAL_TIME_CHAT';
export const REAL_TIME_EDITING = 'REAL_TIME_EDITING';
export const REAL_TIME_SCHEDULING = 'REAL_TIME_SCHEDULING';
export const RECORD_KEEPING = 'RECORD_KEEPING';
export const RECORDING = 'RECORDING';
export const RECORDING_BOOKMARKING = 'RECORDING_BOOKMARKING';
export const RECURRING_BILLING = 'RECURRING_BILLING';
export const REGISTRATION = 'REGISTRATION';
export const REGISTRATION_MANAGEMENT = 'REGISTRATION_MANAGEMENT';
export const REGULATORY_COMPLIANCE = 'REGULATORY_COMPLIANCE';
export const REPORT_CUSTOMIZATION = 'REPORT_CUSTOMIZATION';
export const REPORTING = 'REPORTING';
export const REPORTING_ANALYTICS = 'REPORTING_ANALYTICS';
export const REPORTING_DASHBOARDS = 'REPORTING_DASHBOARDS';
export const REPORTING_EVENT_ANALYTICS = 'REPORTING_EVENT_ANALYTICS';
export const REPORTS_ANALYTICS = 'REPORTS_ANALYTICS';
export const REPORTS_DASHBOARDS = 'REPORTS_DASHBOARDS';
export const RESERVED_SEATING = 'RESERVED_SEATING';
export const RESOURCE_MANAGEMENT = 'RESOURCE_MANAGEMENT';
export const RESOURCE_SCHEDULING = 'RESOURCE_SCHEDULING';
export const RESPONSE_AUTOMATION = 'RESPONSE_AUTOMATION';
export const RESPONSE_MANAGEMENT = 'RESPONSE_MANAGEMENT';
export const RESTAURANT_POS = 'RESTAURANT_POS';
export const RETAIL_POS = 'RETAIL_POS';
export const RETURNS_MANAGEMENT = 'RETURNS_MANAGEMENT';
export const REVENUE_MANAGEMENT = 'REVENUE_MANAGEMENT';
export const REVIEWS_MANAGEMENT = 'REVIEWS_MANAGEMENT';
export const ROLE_BASED_ACCESS = 'ROLE_BASED_ACCESS';
export const ROLE_BASED_ACCESS_CONTROL = 'ROLE_BASED_ACCESS_CONTROL';
export const ROOM_BOOKING_MANAGEMENT = 'ROOM_BOOKING_MANAGEMENT';
export const SALES_INTELLIGENCE = 'SALES_INTELLIGENCE';
export const SALES_MARKETING = 'SALES_MARKETING';
export const SCALABILITY = 'SCALABILITY';
export const SCHEDULED_RECORDING = 'SCHEDULED_RECORDING';
export const SCHEDULING = 'SCHEDULING';
export const SCHEDULING_APPOINTMENTS = 'SCHEDULING_APPOINTMENTS';
export const SCREEN_ACTIVITY_RECORDING = 'SCREEN_ACTIVITY_RECORDING';
export const SCREEN_SHARING = 'SCREEN_SHARING';
export const SCREENSHARE = 'SCREENSHARE';
export const SEARCH_ENGINE_SUBMISSION = 'SEARCH_ENGINE_SUBMISSION';
export const SEARCH_FUNCTION = 'SEARCH_FUNCTION';
export const SEARCH_MARKETING = 'SEARCH_MARKETING';
export const SEARCHABLE = 'SEARCHABLE';
export const SEASON_TICKETS = 'SEASON_TICKETS';
export const SECURITY = 'SECURITY';
export const SEGMENTATION = 'SEGMENTATION';
export const SELF_SERVICE_PORTAL = 'SELF_SERVICE_PORTAL';
export const SENDING_OUTBOUND_EMAILS = 'SENDING_OUTBOUND_EMAILS';
export const SEO = 'SEO';
export const SEO_CONTENT_AUTHORING = 'SEO_CONTENT_AUTHORING';
export const SEO_MANAGEMENT = 'SEO_MANAGEMENT';
export const SEO_TOOLS = 'SEO_TOOLS';
export const SERVICE_HISTORY = 'SERVICE_HISTORY';
export const SERVICE_LEVEL_AGREEMENT = 'SERVICE_LEVEL_AGREEMENT';
export const SERVICE_MANAGEMENT = 'SERVICE_MANAGEMENT';
export const SESSION_MANAGEMENT = 'SESSION_MANAGEMENT';
export const SHIPPING_TAX = 'SHIPPING_TAX';
export const SHOPPING_CART_RECOMMENDATIONS = 'SHOPPING_CART_RECOMMENDATIONS';
export const SHORT_CODE = 'SHORT_CODE';
export const SHOWCASE = 'SHOWCASE';
export const SITE_ANALYTICS = 'SITE_ANALYTICS';
export const SITE_INTERCEPT_SURVEY = 'SITE_INTERCEPT_SURVEY';
export const SITE_SELECTION = 'SITE_SELECTION';
export const SKIP_LOGIC = 'SKIP_LOGIC';
export const SLA_STATUS_INDICATORS = 'SLA_STATUS_INDICATORS';
export const SLIDESHOW = 'SLIDESHOW';
export const SMART_TRIGGERS = 'SMART_TRIGGERS';
export const SOCIAL_ADS = 'SOCIAL_ADS';
export const SOCIAL_CAMPAIGNS = 'SOCIAL_CAMPAIGNS';
export const SOCIAL_ENGAGEMENT = 'SOCIAL_ENGAGEMENT';
export const SOCIAL_INTEGRATION = 'SOCIAL_INTEGRATION';
export const SOCIAL_MARKETING = 'SOCIAL_MARKETING';
export const SOCIAL_MEDIA_INTEGRATION = 'SOCIAL_MEDIA_INTEGRATION';
export const SOCIAL_MEDIA_INTEGRATIONS = 'SOCIAL_MEDIA_INTEGRATIONS';
export const SOCIAL_MEDIA_MANAGEMENT = 'SOCIAL_MEDIA_MANAGEMENT';
export const SOCIAL_MEDIA_MONITORING = 'SOCIAL_MEDIA_MONITORING';
export const SOCIAL_MEDIA_PROMOTION = 'SOCIAL_MEDIA_PROMOTION';
export const SOCIAL_NETWORK_INTEGRATION = 'SOCIAL_NETWORK_INTEGRATION';
export const SOCIAL_NETWORKING = 'SOCIAL_NETWORKING';
export const SOCIAL_SHARING = 'SOCIAL_SHARING';
export const SOFTWARE_INTEGRATION = 'SOFTWARE_INTEGRATION';
export const SOFTWARE_INTEGRATIONS = 'SOFTWARE_INTEGRATIONS';
export const STORAGE_VIEWING_CAPABILITIES = 'STORAGE_VIEWING_CAPABILITIES';
export const STOREFRONT_DESIGN_TOOLS = 'STOREFRONT_DESIGN_TOOLS';
export const SUBSCRIBE_UNSUBSCRIBE = 'SUBSCRIBE_UNSUBSCRIBE';
export const SUCCESS_METRICS_TRACKING = 'SUCCESS_METRICS_TRACKING';
export const SUPPLIER_PROCUREMENT = 'SUPPLIER_PROCUREMENT';
export const SUPPLY_CHAIN_MANAGEMENT = 'SUPPLY_CHAIN_MANAGEMENT';
export const SURVEY_BUILDER = 'SURVEY_BUILDER';
export const SURVEY_FOR_FEEDBACK = 'SURVEY_FOR_FEEDBACK';
export const SURVEY_TEMPLATE = 'SURVEY_TEMPLATE';
export const SURVEYS = 'SURVEYS';
export const SYNCHRONOUS_LEARNING = 'SYNCHRONOUS_LEARNING';
export const SYNDICATION = 'SYNDICATION';
export const TACTICS = 'TACTICS';
export const TAGGING = 'TAGGING';
export const TARGET_ACCOUNT_IDENTIFICATION = 'TARGET_ACCOUNT_IDENTIFICATION';
export const TASK_CREATION_ASSIGNMENT = 'TASK_CREATION_ASSIGNMENT';
export const TASK_MANAGEMENT = 'TASK_MANAGEMENT';
export const TASK_PRIORITIZATION = 'TASK_PRIORITIZATION';
export const TASK_PROGRESS_TRACKING = 'TASK_PROGRESS_TRACKING';
export const TAX_CALCS = 'TAX_CALCS';
export const TAX_FILING = 'TAX_FILING';
export const TAX_MANAGEMENT = 'TAX_MANAGEMENT';
export const TEAM_INBOX = 'TEAM_INBOX';
export const TEMPLATE_MANAGEMENT = 'TEMPLATE_MANAGEMENT';
export const TEMPLATES = 'TEMPLATES';
export const TERRITORY_MANAGEMENT = 'TERRITORY_MANAGEMENT';
export const TEXT_SCHEDULING = 'TEXT_SCHEDULING';
export const THIRD_PARTY_INTEGRATION = 'THIRD_PARTY_INTEGRATION';
export const THIRD_PARTY_INTEGRATIONS = 'THIRD_PARTY_INTEGRATIONS';
export const THIRD_PARTY_STORE_INTEGRATION = 'THIRD_PARTY_STORE_INTEGRATION';
export const THREE_PANE_PROJECT_VIEW = 'THREE_PANE_PROJECT_VIEW';
export const TICKET_BROKERING = 'TICKET_BROKERING';
export const TICKET_COLLABORATION = 'TICKET_COLLABORATION';
export const TICKET_ISSUE_TRACKING = 'TICKET_ISSUE_TRACKING';
export const TICKETING = 'TICKETING';
export const TIME_ATTENDENCE_TRACKING = 'TIME_ATTENDENCE_TRACKING';
export const TIME_TRACKING_INTEGRATION = 'TIME_TRACKING_INTEGRATION';
export const TO_DO_LISTS = 'TO_DO_LISTS';
export const TRAINING_MANAGEMENT = 'TRAINING_MANAGEMENT';
export const TRANSACTIONAL_SMS = 'TRANSACTIONAL_SMS';
export const TRANSFERS_ROUTING = 'TRANSFERS_ROUTING';
export const TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION';
export const TWO_WAY_MESSAGING = 'TWO_WAY_MESSAGING';
export const UNIFIED_CUSTOMER_EXPERIENCE = 'UNIFIED_CUSTOMER_EXPERIENCE';
export const UPDATES = 'UPDATES';
export const UPLOAD = 'UPLOAD';
export const URL_BUILDER = 'URL_BUILDER';
export const USAGE_TRACKING_ANALYTICS = 'USAGE_TRACKING_ANALYTICS';
export const USER_FRIENDLY_INTERFACE = 'USER_FRIENDLY_INTERFACE';
export const USER_MANAGEMENT = 'USER_MANAGEMENT';
export const USER_PERMISSIONS = 'USER_PERMISSIONS';
export const USER_REGISTRATION_PROCESS = 'USER_REGISTRATION_PROCESS';
export const USER_ROLE_ACCESS_MANAGEMENT = 'USER_ROLE_ACCESS_MANAGEMENT';
export const UTILITIES = 'UTILITIES';
export const VENUE_MANAGEMENT = 'VENUE_MANAGEMENT';
export const VERSION_CONTROL = 'VERSION_CONTROL';
export const VIDEO_CALL_RECORDING = 'VIDEO_CALL_RECORDING';
export const VIDEO_HOSTING = 'VIDEO_HOSTING';
export const VIDEO_LOOPING = 'VIDEO_LOOPING';
export const VIDEO_STREAMING = 'VIDEO_STREAMING';
export const VIEWS_DASHBOARDS_REPORTS = 'VIEWS_DASHBOARDS_REPORTS';
export const VIP_DISCOUNT_TICKETS = 'VIP_DISCOUNT_TICKETS';
export const VISITOR_IDENTIFICATION = 'VISITOR_IDENTIFICATION';
export const VISUAL_MERCHANDISING = 'VISUAL_MERCHANDISING';
export const VOICEMAIL_AND_NOTIFICATIONS = 'VOICEMAIL_AND_NOTIFICATIONS';
export const W3C_COMPLIANCE = 'W3C_COMPLIANCE';
export const WEB_PORTAL = 'WEB_PORTAL';
export const WEB_SERVICES = 'WEB_SERVICES';
export const WEB_TRAFFIC_ANALYTICS = 'WEB_TRAFFIC_ANALYTICS';
export const WEBSITE_ANALYTICS_INTEGRATION = 'WEBSITE_ANALYTICS_INTEGRATION';
export const WEBSITE_BUILDER = 'WEBSITE_BUILDER';
export const WEBSITE_VISITOR_TRACKING = 'WEBSITE_VISITOR_TRACKING';
export const WELLNESS_ASSESSMENTS = 'WELLNESS_ASSESSMENTS';
export const WHISPER_COACHING = 'WHISPER_COACHING';
export const WHITE_LABELING = 'WHITE_LABELING';
export const WIDGETS = 'WIDGETS';
export const WORD_PROCESSOR = 'WORD_PROCESSOR';
export const WORK_ORDER_MANAGEMENT = 'WORK_ORDER_MANAGEMENT';
export const WORKFLOW_AUTOMATION = 'WORKFLOW_AUTOMATION';
export const WORKFLOW_CONFIGURATION = 'WORKFLOW_CONFIGURATION';
export const WYSIWYG_FORM_DESIGNER = 'WYSIWYG_FORM_DESIGNER';